/**跳转查看页面详情组件（查看详情 >)**/
export const JumpIntro = ({ desc = '查看详情', className = '' }: { desc?: string; className?: string }) => {
  return (
    <div className={className}>
      <span>{desc}</span>&nbsp;&gt;
    </div>
  );
};
